"use client";

import { useTranslations } from "next-intl";
import { SectionShell, EditorialTitle, GradientText, RevealOnScroll } from "./_primitives";

export default function WeRunItSection() {
    const t = useTranslations();

    const services = [1, 2, 3, 4, 5, 6].map((i) => ({
        num: String(i).padStart(2, "0"),
        tag: t(`joinInstructor_run_item${i}_tag`),
        title: t(`joinInstructor_run_item${i}_title`),
        desc: t(`joinInstructor_run_item${i}_desc`),
        highlight: i === 1,
    }));

    return (
        <SectionShell label={t("joinInstructor_run_marker")}>
            <div className="grid lg:grid-cols-3 gap-8 sm:gap-10 items-end mb-10 sm:mb-14">
                <RevealOnScroll className="lg:col-span-2">
                    <EditorialTitle className="text-4xl sm:text-5xl md:text-7xl">
                        {t("joinInstructor_run_title_part1")}{" "}
                        <GradientText>{t("joinInstructor_run_title_emphasis")}</GradientText>
                    </EditorialTitle>
                </RevealOnScroll>
                <RevealOnScroll delay={0.1}>
                    <p
                        className="text-gray-500 dark:text-white/55 italic text-base"
                        style={{ fontFamily: "'Playfair Display', Georgia, serif" }}
                    >
                        {t("joinInstructor_run_subtitle_part1")}{" "}
                        <span className="text-gray-900 dark:text-white not-italic font-semibold">
                            {t("joinInstructor_run_subtitle_emphasis")}
                        </span>{" "}
                        {t("joinInstructor_run_subtitle_part2")}
                    </p>
                </RevealOnScroll>
            </div>

            <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-4">
                {services.map((s, i) => (
                    <RevealOnScroll key={s.num} delay={i * 0.06}>
                        <div
                            className={`relative h-full rounded-2xl p-7 ${
                                s.highlight
                                    ? "bg-gradient-to-br from-[#FF7A1A] via-[#FF3B5C] to-[#E51578] text-white"
                                    : "border border-gray-200 dark:border-white/10 bg-gray-50 dark:bg-white/[0.03]"
                            }`}
                        >
                            <div
                                className={`text-[10px] uppercase tracking-[0.25em] mb-5 font-mono ${
                                    s.highlight ? "text-white/80" : "text-primary"
                                }`}
                            >
                                {s.num} · {s.tag}
                            </div>
                            <h3
                                className={`text-xl font-bold mb-3 leading-tight ${
                                    s.highlight ? "text-white" : "text-gray-900 dark:text-white"
                                }`}
                                style={{ fontFamily: "'Playfair Display', Georgia, serif" }}
                            >
                                {s.title}
                            </h3>
                            <p
                                className={`text-sm leading-relaxed ${
                                    s.highlight ? "text-white/90" : "text-gray-500 dark:text-white/55"
                                }`}
                            >
                                {s.desc}
                            </p>
                        </div>
                    </RevealOnScroll>
                ))}
            </div>
        </SectionShell>
    );
}
